import authCheckApp from './authCheckApp'

/**
 * 创建群聊
 * @since 1.0.0
 * @param {Object} obj - 包含了群聊的信息
 * @param {string} obj.tribeName 群聊名字
 * @param {string} obj.tribeNotice 群公告
 * @returns {string} 返回一个群的id eg："tribeId":"2250003386"
 * @example
 * 
 * createTribe({
 *   tribeName: '群聊名字',
 *   tribeNotice: '群公告'
 * })
 */
function createTribe(obj) {
    return new Promise((resolve, reject) => {
        authCheckApp()
            .then(() => {
                // 发起请求
                window.WebViewJavascriptBridge.callHandler('createTribe', {
                    'tribeName': obj.tribeName,
                    'tribeNotice': obj.tribeNotice,
                }, (response) => {
                    if (typeof response === 'string') {
                        response = JSON.parse(response)
                    }
                    // 返回状态值为0成功
                    if (response.status === 0) {
                        resolve(response)
                    } else {
                        reject(response)
                    }
                })
            }).catch(err => {
                reject(err)
            })
    })
}

export default createTribe